import { ApiUrls } from 'shared/config/model/urls';

import { createApi } from '@reduxjs/toolkit/query/react';
import { AxiosRequestHeaders } from 'axios';

import { MetricData } from 'features/admin/model/IMetrics';

import { buildQuery } from 'shared/api/query';

import httpBaseQuery from '../../../shared/api/rtk-query/httpBaseQuery';

interface MetricsParams {
    dateFrom?: string;
    dateTo?: string;
    period?: 'day' | 'week' | 'month';
}

export const metricsAPI = createApi({
    reducerPath: 'metricsAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['Metrics'],
    refetchOnMountOrArgChange: 30, // Обновляем каждые 30 секунд
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getDashboardMetrics: build.query<MetricData[], MetricsParams>({
            query: (params) => {
                const queryParams: Record<string, string> = {};

                if (params.dateFrom) {
                    queryParams['dateMetrics[after]'] = params.dateFrom;
                }
                if (params.dateTo) {
                    queryParams['dateMetrics[before]'] = params.dateTo;
                }
                if (params.period) {
                    queryParams['period'] = params.period;
                }

                return {
                    path: buildQuery(ApiUrls.ADMIN_DASHBOARD_METRICS, queryParams),
                    headers: {
                        Accept: 'application/json',
                    } as unknown as AxiosRequestHeaders,
                };
            },
            providesTags: ['Metrics'],
            transformResponse: (response: MetricData[]) => {
                return response.sort((a, b) =>
                    new Date(a.date_metrics).getTime() - new Date(b.date_metrics).getTime(),
                );
            },
        }),
    }),
});

export const {
    useGetDashboardMetricsQuery,
} = metricsAPI;